{
  "comment": "Mission 2, Watchers (spec §5; S12 owns). Offered at tier 3 with Holdfast ≥ 25 (below it Kell plays comms/m2.json m2.not_yet; Holdfast contracts pay +10 flat below 25 and the 1st and 3rd drop a guaranteed Watch log, contracts.json factionStanding and story.holdfastWatchLogs). Steps, none with a deadline: package (Kell's offer ends at m2.offer.take: the sealed package, a contraband story item, goes in the hold), courier (carry it to guardian-base, a story-owned courier job; the patrol scan fines and never confiscates, and high Authority standing waves the player through but sets hale_logged_route: src/story/m12.ts contrabandScan; the lane graph always has an unclaimed path), reyes (any reply at m2.reyes, the meeting: the named payout m2Watch puts Watch book 7 in the ledger and, when career.guardianKills has entries, the Reyes-named pilot's log, and m12.ts m2NamedLine opens her one line, m2.reyes.named; a Show of a watch log shortens her distrust by a node), raid (m2.raid/come: the lessee barge and its Varro escort spawn through spawnStoryShip, mission-owned traffic). The barge fork (people vs the cause) follows the raid: help (Holdfast +15, Tethys −20, Reyes ally), stand_off (neutral, Reyes cool), warn (Tethys +20 standing and no cash, D-315 #3; Holdfast −40; Reyes hostile, the world flag story.reyesHunts lets the bridge run her as a hunter through the M5 grudge). Lasting trace: story.barge = wreck (helped, stood off) or rig (warned). The resonance meter module is granted by the integration lane (S37) when watchers_helped or watchers_stood_off is set (not after a betrayal). Echoes and callbacks are S11's, keyed on the flags. The Keep the Candle lit run (spec §16.2) is offered by Kell after help or stand off (m12.ts candleRunOffer, contracts.json story.candleRun).",
  "id": "m2",
  "offer": {
    "tier": 3,
    "standing": [{ "faction": "holdfast", "min": 25 }],
    "contact": "kell",
    "comms": "m2.offer"
  },
  "steps": [
    {
      "id": "package",
      "verb": "comms",
      "target": { "kind": "node", "ref": "m2.offer.take" },
      "onDone": {
        "items": [{ "id": "kell_package", "state": "held", "contraband": true }]
      }
    },
    {
      "id": "courier",
      "verb": "courier",
      "contractType": "courier",
      "item": "kell_package",
      "target": { "kind": "station", "ref": "guardian-base" },
      "onDone": {
        "items": [{ "id": "kell_package", "state": "lost", "where": "reyes" }],
        "comms": "m2.reyes"
      }
    },
    {
      "id": "reyes",
      "verb": "comms",
      "target": { "kind": "node", "ref": "m2.reyes" },
      "onDone": {
        "payout": "m2Watch"
      }
    },
    {
      "id": "raid",
      "verb": "comms",
      "target": { "kind": "reply", "ref": "m2.raid/come" },
      "onDone": {
        "commands": [
          { "type": "spawnStoryShip", "key": "m2:barge", "role": "lesseeBarge", "systemId": "site:m2-barge", "missionId": "m2" },
          { "type": "spawnStoryShip", "key": "m2:bargeEscort", "role": "varroContractors", "systemId": "site:m2-barge", "missionId": "m2" }
        ]
      }
    }
  ],
  "forks": [
    {
      "id": "barge",
      "afterStep": "raid",
      "choices": [
        {
          "id": "help",
          "cost": "m2.barge.help",
          "outcome": {
            "setFlags": ["watchers_helped"],
            "reyesState": "ally",
            "standings": [
              { "faction": "holdfast", "delta": 15 },
              { "faction": "tethys", "delta": -20 }
            ],
            "commands": [{ "type": "setWorldFlag", "key": "story.barge", "value": "wreck" }],
            "comms": "m2.after.help"
          }
        },
        {
          "id": "stand_off",
          "cost": "m2.barge.stand_off",
          "outcome": {
            "setFlags": ["watchers_stood_off"],
            "reyesState": "cool",
            "commands": [{ "type": "setWorldFlag", "key": "story.barge", "value": "wreck" }],
            "comms": "m2.after.stand_off"
          }
        },
        {
          "id": "warn",
          "cost": "m2.barge.warn",
          "outcome": {
            "setFlags": ["watchers_betrayed"],
            "reyesState": "hostile",
            "standings": [
              { "faction": "tethys", "delta": 20 },
              { "faction": "holdfast", "delta": -40 }
            ],
            "commands": [
              { "type": "setWorldFlag", "key": "story.barge", "value": "rig" },
              { "type": "setWorldFlag", "key": "story.reyesHunts", "value": true }
            ],
            "comms": "m2.after.warn"
          }
        }
      ]
    }
  ],
  "trace": "trace.barge"
}
